/* eslint-disable react/prop-types */
import React from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Placeholder,
  Accordion,
  AccordionBody,
  AccordionTitle,
} from '@thd-olt-component-react/core-ui';
import {
  QuestionsAndAnswersAccordionTitle,
  QuestionsAndAnswersAccordionBody,
} from '@thd-olt-component-react/questions-and-answers';
import {
  RatingsAndReviewsAccordionTitle,
  RatingsAndReviewsAccordionBody,
} from '@thd-olt-component-react/ratings-and-reviews';
import { DynamicComponent } from '@thd-nucleus/app-render';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import PhoneNumber from '@gcc/pip-components/dist/templates/ProductSummary/PhoneNumber';
import { RelatedSearch } from '@thd-olt-component-react/related-search';
import { EmtLinks } from '@thd-olt-component-react/emt-links';
import ProductOverview from '../productOverview';
import { SpecificationsSuspense } from '../Specifications/SpecificationsSuspense';

import { Container, Row } from '../styles';

export const ProductDetailsAccordion = ({
  isMobile,
  productOverviewRef,
  expanded,
  handleAccordionChange,
  omsId,
  pipSupportPhoneNumber,
  hideProductSpecifications,
  specificationsRef,
  questionsRef,
  ratingsRef,
  url,
}) => {
  return (
    <QueryProvider cacheKey="product-details-accordion">
      <Row className={isMobile ? 'gray-background-mobile' : 'gray-background'}>
        <Container className="gray-background-accordion">
          <div id="product-overview" ref={productOverviewRef}>
            <ErrorBoundary name="product-overview">
              <Accordion
                icon={{ size: 'sm' }}
                iconPosition="right"
                key="product-details-accordion"
                className="collapsible-section"
                expanded={expanded['#product-overview']}
                onChange={() => handleAccordionChange('#product-overview')}
              >
                <AccordionTitle className="accordion-title-container qa-result__accordion-header">
                  Product Overview
                </AccordionTitle>
                <AccordionBody>
                  <DynamicComponent pageType="pip">
                    <Hydrator
                      id="product-section-product-overview"
                      className="grid"
                      placeholder={<Placeholder width="100%" height="2000px" color="#F5F5F5" />}
                    >
                      <ProductOverview productId={omsId} isMobile={isMobile} isCt />
                      <PhoneNumber contactNumber={pipSupportPhoneNumber} />
                    </Hydrator>
                  </DynamicComponent>
                </AccordionBody>
              </Accordion>
            </ErrorBoundary>
          </div>
        </Container>
      </Row>
      {!hideProductSpecifications && (
        <Row className={isMobile ? 'gray-background-mobile' : 'gray-background'}>
          <Container className="gray-background-accordion">
            <div id="specifications" ref={specificationsRef}>
              <ErrorBoundary name="specifications">
                <Accordion
                  icon={{ size: 'sm' }}
                  iconPosition="right"
                  key="specifications-accordion"
                  className="collapsible-section"
                  expanded={expanded['#specifications']}
                  onChange={() => handleAccordionChange('#specifications')}
                >
                  <AccordionTitle className="accordion-title-container qa-result__accordion-header">
                    Specifications
                  </AccordionTitle>
                  <AccordionBody>
                    <DynamicComponent pageType="pip">
                      <Hydrator
                        id="product-section-specifications"
                        className="grid"
                        placeholder={<Placeholder width="100%" height="2000px" color="#F5F5F5" />}
                      >
                        <SpecificationsSuspense productId={+omsId} />
                      </Hydrator>
                    </DynamicComponent>
                  </AccordionBody>
                </Accordion>
              </ErrorBoundary>
            </div>
          </Container>
        </Row>
      )}
      <Row className={isMobile ? 'gray-background-mobile' : 'gray-background'}>
        <Container className="gray-background-accordion">
          <div id="bazaar-voice-QA" ref={questionsRef}>
            <ErrorBoundary name="bazaar-voice-QA">
              <div id="product-section-qa" className="product-section-qa">
                <Accordion
                  key="questions-answers-accordion"
                  icon={{ size: 'sm' }}
                  iconPosition="right"
                  className="collapsible-section"
                  expanded={expanded['#bazaar-voice-QA']}
                  onChange={() => handleAccordionChange('#bazaar-voice-QA')}
                >
                  <AccordionTitle className="accordion-title-container">
                    <QuestionsAndAnswersAccordionTitle
                      itemId={omsId}
                      layoutGroup={{
                        tag: Row,
                      }}
                      hydrator={{
                        className: 'grid',
                      }}
                      dynamic={{
                        pageType: 'pip',
                      }}
                    />
                  </AccordionTitle>
                  <AccordionBody>
                    <DynamicComponent pageType="pip">
                      <Hydrator
                        id="product-section-questions-answers"
                        className="grid"
                        placeholder={<Placeholder width="100%" height="700px" color="#F5F5F5" />}
                      >
                        <QuestionsAndAnswersAccordionBody
                          itemId={omsId}
                          seoPageNumber={1}
                          layoutGroup={{
                            tag: Row,
                          }}
                        />
                      </Hydrator>
                    </DynamicComponent>
                  </AccordionBody>
                </Accordion>
              </div>
            </ErrorBoundary>
          </div>
        </Container>
      </Row>
      <Row className={isMobile ? 'gray-background-mobile' : 'gray-background'}>
        <Container className="gray-background-accordion">
          <div id="bazaar-voice-reviews" ref={ratingsRef}>
            <ErrorBoundary name="bazaar-voice-reviews">
              <div id="product-section-rr" className="product-section-rr">
                <Accordion
                  key="ratings-reviews-accordion"
                  icon={{ size: 'sm' }}
                  iconPosition="right"
                  className="collapsible-section"
                  expanded={expanded['#bazaar-voice-reviews']}
                  onChange={() => handleAccordionChange('#bazaar-voice-reviews')}
                >
                  <AccordionTitle className="accordion-title-container">
                    <RatingsAndReviewsAccordionTitle
                      itemId={omsId}
                      layoutGroup={{
                        tag: Row,
                      }}
                      hydrator={{
                        className: 'grid',
                      }}
                      dynamic={{
                        pageType: 'pip',
                      }}
                    />
                  </AccordionTitle>
                  <AccordionBody>
                    <DynamicComponent pageType="pip">
                      <Hydrator
                        id="product-section-ratings-reviews"
                        className="grid"
                        placeholder={<Placeholder width="100%" height="2000px" color="#F5F5F5" />}
                      >
                        <RatingsAndReviewsAccordionBody itemId={omsId} prosAndCons />
                      </Hydrator>
                    </DynamicComponent>
                  </AccordionBody>
                </Accordion>
              </div>
            </ErrorBoundary>
          </div>
        </Container>
      </Row>
      <section id="related-search" className="col__12-12">
        <RelatedSearch itemId={omsId} />
      </section>
      <EmtLinks path={url?.pathname || ''} />
    </QueryProvider>
  );
};

export default ProductDetailsAccordion;
